/**
 * @flow
 * @relayHash c34ee2649addc60ab3e530997048cec2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SellingShops_queryResult$ref = any;
export type ShopSort = "a_to_z" | "best_selling" | "discount" | "highest_rating" | "most_popular" | "nearest" | "price_asc" | "price_desc" | "z_to_a" | "%future added value";
export type VendorVariantsSearchInput = {
  root_variant_id: number,
  sort?: ?ShopSort,
  page?: ?PageInfoInput,
  coordinates?: ?LocationCoordinatesInput,
};
export type PageInfoInput = {
  limit?: ?number,
  offset?: ?number,
};
export type LocationCoordinatesInput = {
  latitude?: ?number,
  longitude?: ?number,
};
export type SellingShopsQueryVariables = {|
  input?: ?VendorVariantsSearchInput
|};
export type SellingShopsQueryResponse = {|
  +$fragmentRefs: SellingShops_queryResult$ref
|};
export type SellingShopsQuery = {|
  variables: SellingShopsQueryVariables,
  response: SellingShopsQueryResponse,
|};
*/


/*
query SellingShopsQuery(
  $input: VendorVariantsSearchInput
) {
  ...SellingShops_queryResult_2VV6jB
}

fragment SellingShops_queryResult_2VV6jB on Query {
  vendor_variants_search(input: $input) {
    related_sorts {
      name
      display_name
      selected
    }
    result {
      ...VariantData_variantInfo
      id
    }
    page_info {
      ...PaginationData_pageInfo
    }
    errors {
      field
      messages
      code
    }
  }
}

fragment VariantData_variantInfo on Variant {
  product_type
  id
  ref_id
  images
  summary
  images_attachments {
    url_product
  }
  name
  avg_rating
  rating_count
  price
  slug
  vendor_variants_count
  discount_expire_at
  remaining_usage_percentage
  gift_image {
    url_large
    url_original
  }
  gift_text
  gift_included
  min_variant {
    vendor {
      name
      ref_id
      id
    }
    slug
    name
    ref_id
    root_variant_id
    discount_expire_at
    remaining_usage_percentage
    total_on_hand
    price
    original_price
    id
  }
  has_offer
  hot_deal
  has_discount
  wish_listed
  root_variant_id
  root_variant {
    ref_id
    wish_listed
    id
  }
  original_price
  discount
  total_on_hand
  option_values {
    id
    presentation
  }
  vendor {
    id
    ref_id
    name
    logo_url
    avg_rating
    rating_count
    followed
    grouped_shipping_methods {
      code
      title
      description
    }
    payment_methods {
      id
      ref_id
      name
      description
      type
      code
    }
  }
}

fragment PaginationData_pageInfo on PageInfo {
  current_page
  items_count
  limit
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VendorVariantsSearchInput",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "avg_rating",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rating_count",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discount_expire_at",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "remaining_usage_percentage",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "root_variant_id",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total_on_hand",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "original_price",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "wish_listed",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SellingShopsQuery",
  "id": null,
  "text": "query SellingShopsQuery(\n  $input: VendorVariantsSearchInput\n) {\n  ...SellingShops_queryResult_2VV6jB\n}\n\nfragment SellingShops_queryResult_2VV6jB on Query {\n  vendor_variants_search(input: $input) {\n    related_sorts {\n      name\n      display_name\n      selected\n    }\n    result {\n      ...VariantData_variantInfo\n      id\n    }\n    page_info {\n      ...PaginationData_pageInfo\n    }\n    errors {\n      field\n      messages\n      code\n    }\n  }\n}\n\nfragment VariantData_variantInfo on Variant {\n  product_type\n  id\n  ref_id\n  images\n  summary\n  images_attachments {\n    url_product\n  }\n  name\n  avg_rating\n  rating_count\n  price\n  slug\n  vendor_variants_count\n  discount_expire_at\n  remaining_usage_percentage\n  gift_image {\n    url_large\n    url_original\n  }\n  gift_text\n  gift_included\n  min_variant {\n    vendor {\n      name\n      ref_id\n      id\n    }\n    slug\n    name\n    ref_id\n    root_variant_id\n    discount_expire_at\n    remaining_usage_percentage\n    total_on_hand\n    price\n    original_price\n    id\n  }\n  has_offer\n  hot_deal\n  has_discount\n  wish_listed\n  root_variant_id\n  root_variant {\n    ref_id\n    wish_listed\n    id\n  }\n  original_price\n  discount\n  total_on_hand\n  option_values {\n    id\n    presentation\n  }\n  vendor {\n    id\n    ref_id\n    name\n    logo_url\n    avg_rating\n    rating_count\n    followed\n    grouped_shipping_methods {\n      code\n      title\n      description\n    }\n    payment_methods {\n      id\n      ref_id\n      name\n      description\n      type\n      code\n    }\n  }\n}\n\nfragment PaginationData_pageInfo on PageInfo {\n  current_page\n  items_count\n  limit\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SellingShopsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "SellingShops_queryResult",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SellingShopsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendor_variants_search",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "VendorVariantsSearchInput"
          }
        ],
        "concreteType": "VendorVariantsSearchResult",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "related_sorts",
            "storageKey": null,
            "args": null,
            "concreteType": "SortOption",
            "plural": true,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "display_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "selected",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "result",
            "storageKey": null,
            "args": null,
            "concreteType": "Variant",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "gift_image",
                "storageKey": null,
                "args": null,
                "concreteType": "ImageAttachment",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url_large",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url_original",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "product_type",
                "args": null,
                "storageKey": null
              },
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "images",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "summary",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "images_attachments",
                "storageKey": null,
                "args": null,
                "concreteType": "ImageAttachment",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url_product",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              v1,
              v3,
              v4,
              v5,
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vendor_variants_count",
                "args": null,
                "storageKey": null
              },
              v7,
              v8,
              v9,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "gift_text",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "gift_included",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "min_variant",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": false,
                "selections": [
                  v7,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shop",
                    "plural": false,
                    "selections": [
                      v1,
                      v2,
                      v9
                    ]
                  },
                  v1,
                  v2,
                  v10,
                  v6,
                  v8,
                  v11,
                  v5,
                  v12,
                  v9
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_offer",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hot_deal",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_discount",
                "args": null,
                "storageKey": null
              },
              v13,
              v10,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "root_variant",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": false,
                "selections": [
                  v2,
                  v13,
                  v9
                ]
              },
              v12,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discount",
                "args": null,
                "storageKey": null
              },
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "option_values",
                "storageKey": null,
                "args": null,
                "concreteType": "OptionValue",
                "plural": true,
                "selections": [
                  v9,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "presentation",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Shop",
                "plural": false,
                "selections": [
                  v9,
                  v2,
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "logo_url",
                    "args": null,
                    "storageKey": null
                  },
                  v3,
                  v4,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "followed",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "grouped_shipping_methods",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorGroupedShipmentResult",
                    "plural": true,
                    "selections": [
                      v14,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      v15
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payment_methods",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PaymentMethod",
                    "plural": true,
                    "selections": [
                      v9,
                      v2,
                      v1,
                      v15,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      v14
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "page_info",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "current_page",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "items_count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "limit",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "errors",
            "storageKey": null,
            "args": null,
            "concreteType": "Error",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "field",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "messages",
                "args": null,
                "storageKey": null
              },
              v14
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3121e3fdd4cb2b6f63e9baa7e0f3c245';
module.exports = node;
